import { Star, Quote, PenLine } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS, GOOGLE_REVIEW_URL } from "./data";

const Testimonials = () => (
  <section id="reviews" data-testid="testimonials-section" className="bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHead num="06" eyebrow="Reviews" title="What Our Customers Say" testid="testimonials-head" />
        <Reveal delay={0.15} className="max-w-sm">
          <div
            className="flex items-center gap-4 rounded-xl border border-gold/40 bg-gold/10 px-5 py-3.5"
            data-testid="testimonials-rating-badge"
          >
            <span className="font-display text-3xl font-extrabold text-navy">5.0</span>
            <span>
              <span className="flex gap-0.5" aria-hidden="true">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-gold text-gold" />
                ))}
              </span>
              <span className="mt-0.5 block text-xs font-semibold text-slate-600">
                Rated on Google Reviews
              </span>
            </span>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 columns-1 gap-6 sm:columns-2 lg:columns-3" data-testid="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.slug} delay={(i % 3) * 0.08} className="mb-6 break-inside-avoid">
            <figure
              data-testid={`testimonial-card-${i}`}
              className="relative flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-22px_rgba(11,25,44,0.25)]"
            >
              <Quote size={22} className="text-gold/50" aria-hidden="true" />
              <div className="mt-3 flex gap-1" aria-label="5 star rating">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={15} className="fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">{t.quote}</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-gold">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-bold text-navy">{t.name}</span>
                  <span className="block text-xs text-slate-500">{t.meta}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12 text-center">
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="leave-review-button"
            className="inline-flex items-center gap-2.5 rounded-full border-2 border-navy px-8 py-4 text-[13px] font-extrabold tracking-[0.14em] text-navy transition-[background-color,color,border-color,transform] duration-200 hover:scale-[1.03] hover:border-gold hover:bg-gold hover:text-navy"
          >
            <PenLine size={16} /> LEAVE US A GOOGLE REVIEW
          </a>
          <p className="mt-3 text-xs text-slate-400">
            Worked with Teo's Painting? Your review helps our local business grow.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Testimonials;
